import {Box, IconButton, Stack, SvgIcon, SvgIconProps, SxProps, Typography} from "@mui/material";
import YouTubeIcon from "@mui/icons-material/YouTube";
import InstagramIcon from "@mui/icons-material/Instagram";

// TikTok + Telegram als SVG
function TikTokIcon(props: any) {
  return (
      <SvgIcon {...props} viewBox="0 0 24 24">
        <path
            d="M12 2c1.5 0 2.9.5 4.1 1.3v3.2c-.9-.5-1.8-.8-2.8-.9v7.4c0 2.9-2.3 5.2-5.2 5.2S3 15.9 3 13s2.3-5.2 5.2-5.2c.4 0 .8 0 1.1.1v3c-.3-.1-.6-.2-.9-.2-1.2 0-2.2 1-2.2 2.3s1 2.3 2.3 2.3 2.3-1 2.3-2.3V2h2z"/>
      </SvgIcon>
  );
}

function TelegramIcon(props: any) {
  return (
      <SvgIcon {...props} viewBox="0 0 24 24">
        <path
            d="M9.5 15.5 8.9 19c.4 0 .6-.2.9-.4l2.2-2 4.6 3.3c.8.5 1.3.2 1.5-.8l2.7-12.7c.3-1.2-.4-1.7-1.2-1.4L2.9 10.3c-1.2.5-1.2 1.1-.2 1.4l4.5 1.4 10.5-6.6c.5-.3.9-.1.6.2l-8.8 8.8Z"/>
      </SvgIcon>
  );
}

type SocialLinkProps = {
  icon: React.ReactNode;
  label: string;
  href: string;
  variant: "ICONS_ONLY" | "ICONS_WITH_LABELS";
};

function SocialLink({icon, label, href, variant}: SocialLinkProps) {
  if (variant === "ICONS_ONLY") {
    return (
        <IconButton
            component="a"
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
            title={label}
        >
          {icon}
        </IconButton>
    );
  }

  return (
      <Stack direction="row" alignItems="center" spacing={1.25}>
        <IconButton
            component="a"
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
            title={label}
        >
          {icon}
          <Typography variant="body1" fontWeight={600} lineHeight={1.2}>
            {label}
          </Typography>
        </IconButton>
      </Stack>
  );
}

type Variant = "ICONS_ONLY" | "ICONS_WITH_LABELS";

export default function SocialLinks({
                                      variant = "ICONS_WITH_LABELS",
                                      fontSize = "large",
                                      gap = 3,
                                      htmlColor = "#000",
                                      sx
                                    }: {
  variant?: Variant;
  fontSize?: SvgIconProps["fontSize"];
  gap?: number;
  htmlColor?: string;
  sx?: SxProps;
}) {
  return (
      <Box sx={sx} display="flex" gap={gap}>
        <SocialLink
            icon={<TelegramIcon fontSize={fontSize} htmlColor={htmlColor}/>}
            label="Telegram"
            href="https://t.me/iovpressekanal"
            variant={variant}
        />
        <SocialLink
            icon={<TikTokIcon fontSize={fontSize} htmlColor={htmlColor}/>}
            label="TikTok"
            href="https://www.tiktok.com/@iovoelkerrecht"
            variant={variant}
        />
        <SocialLink
            icon={<YouTubeIcon fontSize={fontSize} htmlColor={htmlColor}/>}
            label="YouTube"
            href="https://www.youtube.com/@IOVInternationaleOrganisation"
            variant={variant}
        />
        <SocialLink
            icon={<InstagramIcon fontSize={fontSize} htmlColor={htmlColor}/>}
            label="Instagram"
            href="https://www.instagram.com/iovoelkerrecht"
            variant={variant}
        />
      </Box>
  );
}
